import React, { useContext } from 'react';

export interface FirebaseContextType {
  token?: string;
}

export const FirebaseContext = React.createContext<FirebaseContextType>(undefined!);

export const useFirebaseContext = () => useContext(FirebaseContext);
